for (const section of document.querySelectorAll('[data-microsoft-video]')) {
  const video=section.querySelector('video'),buttons=[...section.querySelectorAll('[data-video-seek]')];
  let pending=null;
  const seek=time=>{video.currentTime=time+.25;pending=null;};
  video.addEventListener('loadedmetadata',()=>{if(pending!==null)seek(pending);});
  for(const button of buttons){
    button.hidden=false;
    button.addEventListener('click',()=>{
      video.pause();
      const time=Number(button.dataset.videoSeek);
      if(video.readyState)seek(time);else {pending=time;video.load();}
      video.focus({preventScroll:true});
      video.scrollIntoView({block:'center',behavior:'instant'});
    });
  }
  video.addEventListener('timeupdate',()=>{
    const current=buttons.findLastIndex(b=>Number(b.dataset.videoSeek)<=video.currentTime);
    buttons.forEach((b,i)=>b.setAttribute('aria-current',i===current?'step':'false'));
  });
  const failed=()=>{
    section.querySelector('[data-video-error]').hidden=false;
    buttons.forEach(b=>b.disabled=true);
  };
  video.addEventListener('error',failed);
  video.querySelector('source').addEventListener('error',failed);
}
